module.exports = __webpack_public_path__ + "img/NVIDIADeveloper.116a8cd.svg";